import React from 'react';
import JobDetailLayout from '../../components/JobDetailLayout';

const HealthcareAssistantJob = () => {
  const sections = [
    {
      title: 'About B & N Enterprise',
      paragraphs: [
        'B & N Enterprise provides warm, trusted care across Weston, Canberra, and the wider ACT. We are here to help older Australians and people living with disability stay independent in their own homes, with their dignity and choices always respected. Our team delivers person-centred care that supports wellbeing and makes everyday life a little easier.'
      ]
    },
    {
      title: 'Role Overview',
      paragraphs: [
        'We are looking for dedicated Healthcare Assistants to join our growing care team. In this role you will provide everyday personal care and support to the people we support in their own homes across Weston, Canberra, and the wider ACT. You will work closely with each person and their family to deliver kind, person-centred care that helps them stay independent and live well.',
        'It is a rewarding opportunity for caring people who want to make a real difference close to home. We welcome experienced care workers, and we are just as happy to hear from those new to the sector who bring the right values and a genuine commitment to quality care.'
      ]
    },
    {
      title: 'Key Responsibilities',
      items: [
        'Deliver high-quality personal care and support to clients in their homes',
        'Assist with daily living activities including personal hygiene, dressing, and mobility',
        'Support clients with meal preparation and nutritional needs',
        'Promote independence, dignity, and wellbeing in all care interactions',
        'Work collaboratively with nursing staff and allied health professionals',
        'Observe and report changes in client condition to appropriate personnel',
        'Follow individual care plans and adhere to NDIS Quality Standards',
        'Maintain accurate documentation and care records',
        'Provide companionship and emotional support to clients'
      ]
    },
    {
      title: 'Essential Requirements',
      items: [
        'Valid working rights in Australia',
        'Compassionate, respectful, and person-centred approach to care',
        'Strong communication and interpersonal skills',
        'Ability to work effectively both independently and as part of a team',
        'Current Working with Vulnerable People (WWVP) registration with Access Canberra, or willingness to obtain before commencing (required under ACT law)',
        'A National Police Check issued within the last 3 years, or a current NDIS Worker Screening Clearance, in line with aged care worker screening requirements',
        'Current First Aid and CPR certification (or willingness to obtain)',
        'Flexibility to work various shifts including weekends',
        'Physical capability to assist with client mobility and transfers'
      ]
    },
    {
      title: 'Desirable Qualifications and Experience',
      items: [
        'Certificate III in Individual Support (Ageing, Home and Community) or equivalent',
        'Experience in aged care, disability support, or community care settings',
        'Understanding of dementia care and person-centred approaches',
        'Knowledge of the NDIS framework and quality standards',
        'Manual handling training and experience',
        'Medication administration training',
        "A valid ACT driver's licence and access to a reliable vehicle"
      ]
    },
    {
      title: 'What We Offer',
      items: [
        'Pay and penalty rates in line with the relevant Modern Award (such as the Aged Care Award 2010 or the Social, Community, Home Care and Disability Services Industry Award) and the National Employment Standards',
        'Salary packaging options available',
        'Comprehensive induction and ongoing professional development',
        'Supportive team environment with regular supervision',
        'Flexible rostering to suit your lifestyle',
        'Modern equipment and resources',
        'Opportunity to make a meaningful difference in your local community'
      ]
    }
  ];

  return (
    <JobDetailLayout
      breadcrumbLabel="Healthcare Assistant"
      title="Healthcare Assistant"
      meta={[
        { label: 'Location', value: '23 Mahony Ct, Weston ACT 2611' },
        { label: 'Employment', value: 'Full-time, part-time, casual' },
        { label: 'Department', value: 'Care Services' }
      ]}
      applyLink="/jobs/healthcare-assistant/apply"
      applyText="Join our dedicated care team and make a meaningful difference in the lives of people in your community."
      recruitmentNote="Shortlisted candidates will be contacted for interview. Working with Vulnerable People (WWVP) registration, a police or NDIS worker screening check, and reference checks form part of our recruitment process."
      sections={sections}
      equalOpportunity="B & N Enterprise is an equal opportunity employer. We warmly welcome applications from all suitably qualified people, whatever their age, gender, cultural background, disability, sexual orientation, or religious beliefs. We are committed to an inclusive workplace that reflects the diverse community we serve."
    />
  );
};

export default HealthcareAssistantJob;
